$(function() {
  const token = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  $(document).ajaxSend(function(e, xhr, options) {
    if (options.type !== 'GET') {
      xhr.setRequestHeader("X-CSRF-Token", token);
    }
  });
});